var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-tv",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M.003-2.23h257.784v128.028H.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.003-2.23l-.01 9.61L61.51 38.988l23.147.67L.003-2.23z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.342-2.23l74.58 38.957V-2.23h-74.58z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M110.875-2.23v49.732H.01v28.419h110.865v49.732h34.114V75.92h110.864V47.502H144.99V-2.23h-34.114z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.933-2.23v36.707l72.963-36.423-72.963-.283z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.243 38.48l20.518-.167 79.711-40.259-21.15.345-79.079 40.08z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.003 84.209v27.235l51.17-26.953-51.17-.285z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.044 85.334l-21.332-.166 80.409 40.034-.53-9.159-58.547-30.71zM19.986 125.878L95.38 86.293l-19.802.131L.004 125.818",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.93 9.017l-60.89 30.196 60.08.225v44.996h-51.17l50.698 27.47.744 13.973-27.08-.323-74.11-36.384v36.707h-54.013V89.17l-69.52 36.609-31.399.098v127.878h511.701V-2.01l-254.5-.211M.271 12.214L0 38.773l53.87.674L.27 12.214z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    fill: "#009fca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.983-2.23h255.986v255.987H255.983z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.004 125.763h270.142v127.994H-.004z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(-.004 258.888) scale(.51604)",
    strokeWidth: "1pt",
    fill: "#009fca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.97-19.81h486.16v515.87H505.97z"
  }), /*#__PURE__*/React.createElement("rect", {
    ry: 0,
    height: 521.41,
    width: 523.49,
    y: -25.343
  })), /*#__PURE__*/React.createElement("path", {
    d: "M478.056 226.298l7.064 20.407-18.439-12.629-18.438 12.626 7.067-20.404-18.458-12.605 22.804.021 7.028-20.416 7.029 20.416 22.804-.015zM420.82 389.054l7.064 20.407-18.439-12.629-18.439 12.626 7.067-20.404-18.457-12.605 22.804.021 7.028-20.416 7.029 20.416 22.804-.015zm57.236-36.843l7.064 20.407-18.439-12.629-18.438 12.626 7.067-20.404-18.458-12.605 22.804.022 7.028-20.417 7.029 20.417 22.804-.016zM231.95 470.254l7.065 20.407-18.439-12.63-18.438 12.627 7.067-20.404-18.458-12.605 22.804.021 7.028-20.416 7.029 20.416 22.804-.015zm43.069-88.429l-7.064-20.407 18.439 12.629 18.438-12.626-7.067 20.404 18.458 12.605-22.804-.021-7.029 20.416-7.028-20.416-22.804.015zm67.248-93.002l-7.063-20.408 18.438 12.63 18.439-12.627-7.067 20.405 18.458 12.604-22.805-.02-7.028 20.416-7.028-20.417-22.805.015zm56.52-19.322l-7.063-20.407 18.438 12.629 18.439-12.626-7.067 20.404 18.458 12.605-22.805-.021-7.028 20.416-7.028-20.416-22.805.015zm-56.52 160.967l-7.063-20.407 18.438 12.629 18.439-12.626-7.067 20.404 18.458 12.605-22.805-.021-7.028 20.416-7.028-20.416-22.805.015zm-67.248 16.457l-7.064-20.407 18.439 12.63 18.438-12.627-7.067 20.404 18.458 12.605-22.804-.021-7.029 20.416-7.028-20.416-22.804.015z",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    fill: "#fff40d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.d2359d512f1fc212c6edac59509775d9.svg";
export { ForwardRef as ReactComponent };